import React, { useState } from "react";
import clsx from "clsx";

const FooterText = ({ initialData, onCancel, saveItems }) => {
    const [formData, setFormData] = useState({
        footer: initialData || "",
    });

    return (
        <form onSubmit={(e) => {
            e.preventDefault();
            saveItems(formData);
        }} style={{ height: '100%' }}>
            <div className="container-fluid mt-4">
                <div className="row mb-3 align-items-center">
                    <textarea
                        className={clsx("form-control")}
                        id="footer"
                        placeholder="Example: Terima kasih sudah berlangganan dengan kami"
                        name="footer"
                        value={formData.footer}
                        onChange={(e) => setFormData({ ...formData, footer: e.target.value })}
                        style={{ fontSize: '14px', height: '100px' }} // Adjust height as needed
                        required
                    />

                </div>

                <div className="form-group mt-auto d-flex justify-content-between">
                    <button type="button" className="btn btn-secondary" style={{ height: '40px' }} onClick={onCancel}>
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary" style={{ height: '40px' }}>
                        Save Footer Text
                    </button>
                </div>
            </div>
        </form>
    );
};

export default FooterText;